export const getClientTimezone = () => {
    const date = new Date();
    const offset = date.getTimezoneOffset();
    const sign = offset > 0 ? '-' : '+';
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    return `${sign}${padZero(hours)}:${padZero(minutes)}`;
};
function padZero(value) {
    return value.toString().padStart(2, '0');
}
